import { jsx as _jsx } from "react/jsx-runtime";
import NextLink from 'next/link.js';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function Link({ item, styles = {}, children }) {
    const { title, url } = item;
    return (_jsx(NextLink, { href: url.as ?? url.href, as: url.as ? url.href : undefined, passHref: true, legacyBehavior: true, children: _jsx("a", { css: styles, href: url.as ?? url.href, children: !children ? title : children }) }));
}
//# sourceMappingURL=Link.js.map